export class ExternalSkinItem {
    get skin() {
        return this._skin;
    }
    set skin(value) {
        this._skin = value;
    }
    get slot() {
        return this._slot;
    }
    set slot(value) {
        this._slot = value;
    }
    get attachment() {
        return this._attachment;
    }
    set attachment(value) {
        this._attachment = value;
    }
}
